module.exports = __webpack_public_path__ + "img/logo-circle-orchard.b21b4885.svg";